import { useEffect, useState } from "react";
import { TicketPercent, X, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";

export const couponOff = (c, type, subtotal, fee) => {
  if (!c) return 0;
  if (c.type === "free_delivery") return type === "delivery" ? fee : 0;
  return Math.round(Math.min(c.type === "percent" ? (subtotal * c.value) / 100 : c.value, subtotal) * 100) / 100;
};

export const couponIssue = (c, type) => {
  if (!c) return "";
  if (!["delivery", "retirada", "local"].includes(type)) return "O cupom vale para entrega, retirada ou consumo no local";
  return c.type === "free_delivery" && type !== "delivery" ? "Cupom de entrega grátis vale só para pedidos de entrega" : "";
};

export function CouponField({ slug, coupon, onChange, initial = "" }) {
  const [code, setCode] = useState(initial);
  const [busy, setBusy] = useState(false);
  const apply = async (c) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/public/menu/${slug}/coupon`, { code: c.trim() });
      onChange(data);
      toast.success("Cupom aplicado");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (initial && !coupon) apply(initial); }, []);
  if (coupon) return (
    <div className="flex items-center gap-2 rounded-lg border border-emerald-300 bg-emerald-50 px-3 py-2 text-sm text-emerald-800" data-testid="coupon-applied">
      <TicketPercent className="h-4 w-4 shrink-0" /><span className="flex-1"><b className="font-mono">{coupon.code}</b> · {coupon.label}</span>
      <button type="button" onClick={() => { onChange(null); setCode(""); }} title="Remover cupom" data-testid="coupon-remove"><X className="h-4 w-4" /></button>
    </div>
  );
  return (
    <div className="flex gap-2">
      <Input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="Tem cupom? Digite aqui" className="bg-white font-mono uppercase" data-testid="coupon-input" />
      <Button type="button" variant="outline" onClick={() => apply(code)} disabled={busy || !code.trim()} data-testid="coupon-apply-btn">{busy && <Loader2 className="h-4 w-4 mr-1 animate-spin" />}Aplicar</Button>
    </div>
  );
}
